module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("\n       | 价格管理\n   ")]), _vm._v(" "), _c('el-form', {
    ref: "search",
    attrs: {
      "model": _vm.price,
      "rules": _vm.price.form_rules,
      "label-position": "left"
    }
  }, [(_vm.editStatus) ? _c('div', {
    staticClass: "wrl-hea"
  }, [_c('div', [_vm._v("\n      当前价格系数：\n      "), _c('span', {
    staticClass: "wrl-font"
  }, [_vm._v("\n          " + _vm._s(_vm.sytemPrice) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "ss"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.sytemPrice)
      }
    }
  }, [_vm._v("修改")])], 1)]) : _c('div', {
    staticClass: "wrl-hea"
  }, [_c('div', [_vm._v("\n      当前价格系数：\n      \n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "editPrice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入大于0的数字"
    },
    model: {
      value: (_vm.price.editPrice),
      callback: function($$v) {
        _vm.$set(_vm.price, "editPrice", $$v)
      },
      expression: "price.editPrice"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editB(_vm.price.editPrice)
      }
    }
  }, [_vm._v("确认修改 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editStatus == true
      }
    }
  }, [_vm._v("取消 ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n    备注：价格计价公式如下\n")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n  单个商品：\n")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n    然后取体积和重量二者之间的较大值为单个商品的运费\n")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n   最后，一类物品的运费为单个商品运费 x 商品数量，订单运费为多类物品运费之和\n")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n       按体积算：（长*宽*高 / 6000） * 价格系数\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n        按重量算：千克重量* 价格系数\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df35bd6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/freightage/priceContort.vue
// module id = 1266
// module chunks = 2